import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  max-inline-size: ${spacing(60.75)}; // 486px
`
export const suggest = css`
  position: relative;

  ::before {
    /* Убираем лишние divider, которые были реализованы через ::before */
    content: none;
  }
`
export const grid = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`

export const errorMessage = css`
  margin-block-start: ${spacing(0.5)};
`

export const icon = css`
  position: absolute;
  top: 0;
  right: 0;
`
